import { db } from './firebase-config.js';

const HelperProfile = {
    async createOrUpdateHelper(userId, profileData) {
        try {
            // Fetch user data to denormalize
            const userDoc = await db.collection('users').doc(userId).get();
            let fullName = '';
            let karmaPoints = 0;
            
            if (userDoc.exists) {
                const userData = userDoc.data();
                fullName = userData.fullName || '';
                karmaPoints = userData.karmaPoints || 0;
            }
            
            await db.collection('helpers').doc(userId).set({
                userId,
                fullName, // Denormalized for performance
                karmaPoints, // Denormalized for performance
                ...profileData,
                isActive: true,
                updatedAt: firebase.firestore.FieldValue.serverTimestamp()
            }, { merge: true });
            
            // Update user record
            await db.collection('users').doc(userId).update({
                isHelper: true
            });
            
            return { success: true };
        } catch (error) {
            return { success: false, error: error.message };
        }
    },
    
    async getAllHelpers(filter = 'all') {
        let query = db.collection('helpers').where('isActive', '==', true);
        
        // Apply server-side filtering for expertise
        if (filter !== 'all') {
            // Use array-contains for expertiseAreas (new format)
            // Note: This won't catch legacy primaryExpertise-only helpers
            query = query.where('expertiseAreas', 'array-contains', filter);
        }
        
        const snapshot = await query.get();
        const helpers = [];
        
        // If filtering and we got no results from array-contains query,
        // fall back to fetching all and filtering client-side for legacy support
        if (filter !== 'all' && snapshot.empty) {
            const allQuery = db.collection('helpers').where('isActive', '==', true);
            const allSnapshot = await allQuery.get();
            
            for (const doc of allSnapshot.docs) {
                const helperData = doc.data();
                
                // Skip helpers that have a status field but aren't approved
                if (helperData.status && helperData.status !== 'approved') {
                    continue;
                }
                
                // Check legacy primaryExpertise field
                if (helperData.primaryExpertise === filter) {
                    await this._processHelper(doc, helpers);
                }
            }
            
            return helpers;
        }
        
        // Process normally filtered results
        for (const doc of snapshot.docs) {
            const helperData = doc.data();
            
            // Skip helpers that have a status field but aren't approved
            if (helperData.status && helperData.status !== 'approved') {
                continue;
            }
            
            await this._processHelper(doc, helpers);
        }
        
        return helpers;
    },
    
    async _processHelper(doc, helpers) {
        const helperData = doc.data();
        
        // Use denormalized data from helper document
        // For legacy helpers without denormalized data, fetch from users collection
        if (helperData.fullName !== undefined) {
            helpers.push({
                id: doc.id,
                ...helperData
            });
        } else {
            // Legacy fallback for existing helpers without denormalized data
            const userDoc = await db.collection('users').doc(doc.id).get();
            if (userDoc.exists) {
                const userData = userDoc.data();
                
                helpers.push({
                    id: doc.id,
                    ...helperData,
                    fullName: userData.fullName,
                    karmaPoints: userData.karmaPoints || 0
                });
            }
        }
    }
};

export { HelperProfile };